// `localized-slugs` holds per-page alternate-language paths and is only
// populated by content pages (home, landing, content-page, news,
// gameserver-index, sustainability) in their setup. Nothing ever cleared
// it, so navigating to a page that doesn't set it (e.g. checkout) left the
// footer language switcher pointing at the previously visited page —
// switching language there redirected back to it instead of staying put.
//
// Reset on every real page transition (route-name change). Content pages
// re-populate it in their own setup, which runs after this middleware;
// query/param-only changes (e.g. checkout step navigation) keep the same
// route name and are left untouched.
export default defineNuxtRouteMiddleware((to, from) => {
  if (to.name !== from.name) {
    useState<Array<{ locale: string; path: string }>>(
      'localized-slugs',
      () => [],
    ).value = [];
  }
});
